import React from 'react';
import { Divider, Dropdown } from '@bynder/design-system';
import { useTranslate } from '@bynder/localization';
import { IconAdd, IconMin } from '@bynder/icons';
import {
    ZoomControlButton,
    ZoomControlsFooter,
    ZoomControlsStyled,
    ZoomControlWrapper,
    ZoomValue,
} from './ZoomControls.styled';
import { parseShortcutForTooltip, WithShortcutLabel } from 'packages/common/WithShortcutLabel';

export const ZOOM_VALUES = [10, 25, 50, 100, 200, 400, 800];

const ZoomControls = ({ onZoomIn, onZoomOut, onZoomToFit, onZoomClick, zoomPercentage, maxZoom, minZoom }) => {
    const disableZoomIn = zoomPercentage >= maxZoom;
    const disableZoomOut = zoomPercentage <= minZoom;
    const { translate } = useTranslate();

    return (
        <ZoomControlsStyled>
            <ZoomControlsFooter>
                <ZoomControlWrapper>
                    <ZoomControlButton
                        title={`${translate('editor.zoom-controls.out')} (${parseShortcutForTooltip(['cmd', '–'])})`}
                        variant="clean"
                        icon={<IconMin />}
                        isDisabled={disableZoomOut}
                        onClick={onZoomOut}
                    />
                    <Dropdown
                        position="bottom-left"
                        trigger={({ isOpen, ...triggerProps }) => (
                            <ZoomValue
                                data-testid="zoom current value"
                                isPressed={isOpen}
                                variant="clean"
                                isFullWidth
                                {...triggerProps}
                            >
                                {zoomPercentage}%
                            </ZoomValue>
                        )}
                    >
                        <Dropdown.Item onClick={onZoomToFit}>
                            <WithShortcutLabel shortcut={['cmd', '1']}>
                                {translate('editor.zoom-controls.fit')}
                            </WithShortcutLabel>
                        </Dropdown.Item>
                        <Divider />
                        {ZOOM_VALUES.map((zoomVal) => (
                            <Dropdown.Item
                                key={zoomVal}
                                isChecked={zoomVal === zoomPercentage}
                                onClick={() => onZoomClick(zoomVal)}
                            >
                                {zoomVal === 100 ? (
                                    <WithShortcutLabel shortcut={['cmd', '0']}>{`${zoomVal}%`}</WithShortcutLabel>
                                ) : (
                                    `${zoomVal}%`
                                )}
                            </Dropdown.Item>
                        ))}
                    </Dropdown>
                    <ZoomControlButton
                        title={`${translate('editor.zoom-controls.in')} (${parseShortcutForTooltip(['cmd', '+'])})`}
                        variant="clean"
                        icon={<IconAdd />}
                        isDisabled={disableZoomIn}
                        onClick={onZoomIn}
                    />
                </ZoomControlWrapper>
            </ZoomControlsFooter>
        </ZoomControlsStyled>
    );
};

export default ZoomControls;
